import React, { useState } from 'react'
import './Estatuto.css'

const statuteFiles = [
  { year: 2026, label: '2026', file: '/pdf/Estatuto 2026.pdf', status: 'Atual' },
  { year: 2019, label: '2019', file: '/pdf/Estatuto - 2019.pdf', status: 'Antigo' },
]

const Estatuto = () => {
  const [selectedYear, setSelectedYear] = useState(2026)
  const selectedStatute = statuteFiles.find((item) => item.year === selectedYear)

  return (
    <div className="estatutoPage">
      <main className="estatutoContent">
        <section className="estatutoHeader">
          <h1>{selectedStatute.status === 'Atual' ? 'Estatuto' : `Estatuto ${selectedStatute.year}`}</h1>
          <p>
            {selectedStatute.status === 'Atual'
              ? 'Baixe o Estatuto ou visualize o PDF diretamente na página para consultar regras, objetivos e diretrizes da ASJF.'
              : 'Esta é uma versão anterior do estatuto. Use o visualizador abaixo para conferir o documento histórico.'}
          </p>

          <div className="estatutoYears">
            {statuteFiles.map((item) => (
              <button
                key={item.year}
                type="button"
                className={`estatutoYearButton ${item.year === selectedYear ? 'active' : ''}`}
                onClick={() => setSelectedYear(item.year)}
              >
                {item.label}
              </button>
            ))}
          </div>
        </section>

        <div className="estatutoViewer">
          <iframe
            className="pdfViewer"
            src={selectedStatute.file}
            title={`Visualizador do Estatuto ${selectedStatute.year}`}
          />
        </div>
      </main>
    </div>
  )
}

export default Estatuto